import {useQuery} from "@tanstack/react-query";
import client from '../../utils/Client'




// GET ALL ROLES
const roles = () => client.get('roles');
export const useGetRoles = () => useQuery(['roles'], () =>roles(), {select: data => data?.data?.result,refetchInterval:60_000})

